import { render, staticRenderFns } from "./app-only-card.vue?vue&type=template&id=527944fd&scoped=true&lang=pug&"
import script from "./app-only-card.vue?vue&type=script&lang=js&"
export * from "./app-only-card.vue?vue&type=script&lang=js&"
import style0 from "./app-only-card.vue?vue&type=style&index=0&id=527944fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527944fd",
  null
  
)

export default component.exports